import { BaseLayout } from "@components/general/base_layout";
import { Header } from "@components/general/header";
import { Outlet } from "react-router-dom";

import PreloadLogo from "@assets/images/logo-sipiat.jpg";
import { useThemeStore } from "@stores/theme.store";
import { useEffect } from "react";

export const AuthPage = () => {
  const { setBottomNavigation } = useThemeStore((state) => state);
  useEffect(() => {
    setBottomNavigation("hidden");
  }, [setBottomNavigation]);
  return (
    <BaseLayout>
      <Header>
        <div className="page-title">
          <div className="tw-pt-24 tw-text-center">
            <img
              src={PreloadLogo}
              alt="Logo Ponpes"
              className="tw-w-3/5 tw-rounded-sm tw-mb-10"
            />
            <div className="tw-text-xl tw-font-medium tw-mt-10">
              Assalamualaikum
              <br />
              Warahmatullahi Wabarakatuh
            </div>
          </div>
        </div>
      </Header>
      <Outlet />
    </BaseLayout>
  );
};
